/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationCnesAliases {
  BREADCRUMB_ACCREDITATION = 'breadcrumb-accreditation',
  FETCH_CNES = 'fetch-cnes',
  FIELD_MESSAGE_CNES = 'field-message-cnes',
  FORM_CNES = 'form-cnes',
  FORM_PANEL = 'form-panel',
  LAYOUT_GENERAL_INFORMATION = 'layout-general-information',
  LIST_PANEL = 'list-panel',
  PANEL_ACCREDITATION_CNES = 'panel-accreditation-cnes',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
}
export { AccreditationCnesAliases };
